import React, { useCallback } from 'react'

import Modal from 'components/Modal'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import { ButtonContainer } from 'styles/shared'

type Props = {
  open: boolean
  closeCallback: () => void
}

const CheckEmailModal = ({ open, closeCallback }: Props) => {
  const onCancelClick = useCallback(() => {
    closeCallback()
  }, [closeCallback])

  return (
    <Modal title="Check your email" isDisplayed={open} closeCallback={onCancelClick} variant="sm">
      <p> We sent you an email that may go to your junk folder. To start receiving alert emails, please click 'Verify Email' in that email within 24 hours. </p>
      <ButtonContainer noBorder>
        <Button decoration="positive" text="Ok" onPress={onCancelClick} />
      </ButtonContainer>
    </Modal>
  )
}

export default CheckEmailModal
